module.exports = __webpack_public_path__ + "trademark2.png?935e07f22ce6138681251e8c581525a7";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark2.png
// module id = 502
// module chunks = 0